import { setContext, getContext } from 'svelte'
import { writable } from 'svelte/store'
import type { Writable } from 'svelte/store'

type HouseHeatLossModal = {
	open: boolean
	value?: number | null
	valueType?: 'GENERIC' | 'CALCULATED'
	formData?: {
		roof: any
		facade: any
		window: any
		zip: any
		floorArea: any
	} | null
}

const defaults: HouseHeatLossModal = {
	open: false,
	value: null,
	valueType: 'GENERIC',
	formData: null
}

const HEAT_LOSS_MODAL_CTX = 'HEAT_LOSS_MODAL_CTX'

export function setHeatLossModalState(data?: HouseHeatLossModal) {
	const state = writable<HouseHeatLossModal>({
		...defaults,
		...(data && { ...data })
	})
	setContext(HEAT_LOSS_MODAL_CTX, state)
	return state
}

export function getHeatLossModalState() {
	return getContext<Writable<HouseHeatLossModal>>(HEAT_LOSS_MODAL_CTX)
}
